


















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CmsDeserializer, SliderPage } from '@/services/CmsDeserializer';
import MatomoContentInteraction from '@/matomo/MatomoContentInteraction';

@Component
export default class Slider extends Vue {
  @Prop({ required: true })
  public localPages: string;

  public currentPage: number = 1;

  public trackInteraction(event: Event) {
    MatomoContentInteraction.fromTarget(event.target).withClickAction().publishInteraction();
  }

  public get pages(): SliderPage[] {
    return CmsDeserializer.parseSlider(this.localPages);
  }

  public get pageCount() {
    return this.pages.length;
  }

  public computeBackgroundStyle(page: SliderPage): string {
    if (!page.imageUrl) {
      return '';
    } else {
      return 'background-image: url("' + page.imageUrl + '")';
    }
  }

  public setPage(index: number) {
    this.currentPage = index;
  }

  public goToPreviousPage() {
    if (this.currentPage === 1) {
      this.currentPage = this.pageCount;
    } else {
      this.currentPage--;
    }
  }

  public goToNextPage() {
    if (this.currentPage === this.pageCount) {
      this.currentPage = 1;
    } else {
      this.currentPage++;
    }
  }

  public handleSwipe(direction: string) {
    if (direction === 'left') {
      this.goToNextPage();
    } else if (direction === 'right') {
      this.goToPreviousPage();
    }
  }
}
